module.exports = __webpack_public_path__ + "img/assistant.3652ac83.png";